import React from 'react';

interface CookieSettingsLinkProps {
  className?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

export const CookieSettingsLink: React.FC<CookieSettingsLinkProps> = ({
  className = '',
  children = 'Cookie-Einstellungen',
  style
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // Dispatch custom event to open cookie settings
    window.dispatchEvent(new Event('openCookieSettings'));
  };

  return (
    <button
      onClick={handleClick}
      className={`cookie-settings-link ${className}`}
      style={style}
    >
      {children}
    </button>
  );
};

// Export also as a simple function to open cookie settings programmatically
export const openCookieSettings = () => {
  window.dispatchEvent(new Event('openCookieSettings'));
};